'use client';

import { useQuery } from '@tanstack/react-query';
import { useAuth } from 'context/AuthContext';
import { functions, httpsCallable } from '@util/firebase';
import { ProductDocument } from 'models/product';

export default function useUpsell({ product_ids }: { product_ids: string[] }) {
  const { userDoc } = useAuth();

  const { data: products, isLoading } = useQuery({
    queryKey: ['upsellProducts', ...product_ids],
    queryFn: async () => {
      if (!product_ids?.length) return [];
      const { data } = await httpsCallable<
        { product_ids: string[] },
        { products: ProductDocument[] }
      >(
        functions,
        'v2_getCartUpsell'
      )({
        product_ids,
      });
      return data.products;
    },
    enabled: !!userDoc,
  });

  return { products, isLoading };
}
